export const incomingCallAction = (payload) => {
  return {
    type: "incomingCall",
    payload,
  };
};
